/** @jsx jsx */
import { jsx } from "theme-ui"
import FocusLock from "react-focus-lock"
import { articleStyles, rem } from "@src/theme"
import { Themed } from "@theme-ui/mdx"

const DonationModal = () => {
  return (
    <div
      sx={{
        pb: [rem(100), null, 0],
      }}
    >
      <div
        sx={{
          bg: "purple",
        }}
      >
        <div
          sx={{
            p: ["5vw", rem(64)],
          }}
        >
          <Themed.h1
            sx={{
              my: 0,
              color: "pink",
            }}
          >
            Every bit counts
          </Themed.h1>
        </div>
      </div>

      <div
        sx={{
          ...articleStyles,
          px: [rem(20), null, rem(116)],
          py: 0,
          m: 0,
        }}
      >
        <p
          sx={{
            maxWidth: [rem(540), null, null, rem(720)],
            px: rem(15),
            mt: rem(35),
            mx: "auto",
            mb: "0 !important",
            textAlign: "center",
          }}
        >
          Your tax-deductible donation builds ongoing LGBTQIA+ inclusion
          throughout the year.{" "}
          <a href="/our-impact" target="_blank">
            Here's how.
          </a>
        </p>
      </div>

      <FocusLock
        sx={{
          px: [rem(20), null, rem(116)],
        }}
      >
        <iframe
          className="gn-iframe"
          src="https://www.givenow.com.au/embed/Y2F1c2VpZD03NjgxJmRvbWFpbj1odHRwOi8vaWRhaG9iaXQub3JnLmF1JnRva2VuPTc2ODE6NzAwYzk1ZDdhMTQxZWE2Mg%3D%3D"
          height="870"
          sx={{
            width: "100%",
          }}
          frameborder="0"
          title="GiveNow donation modal"
        ></iframe>
      </FocusLock>
    </div>
  )
}

export default DonationModal
